import { PaymentFormComponent } from './../../shared/components/payment-form/payment-form.component';
import { AfterViewInit, Component, OnDestroy, ViewChild, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router, RoutesRecognized } from "@angular/router";
// Constants
import { SYDLEClientID } from "../../shared/constants/one-constants";
// Enums
import { Dtm, getDtm, Mapping } from "../../shared/enum/dtm";
// Models
import { Cart } from "../../shared/model/cart";
import { Customer } from "../../shared/model/customer";
import { CustomerPaymentMethod } from "../../shared/model/customer-payment-method";
import { CreditCardData } from 'src/app/shared/model/credit-card-data';
import { SuggestionMessage } from './../../shared/model/sugestion-message';
// Services
import { CartService } from "../../shared/services/cart.service";
import { CheckoutService } from "../../shared/services/checkout.service";
import { CustomerService } from "../../shared/services/customer.service";
import { ProductService } from "../../shared/services/product.service";
import { DtmService } from "../../services/dtm.service";
import { SessionStorageService } from "src/app/shared/services/session-storage.service";
import { UtilsService } from "src/app/shared/services/utils.service";
import { DiscountModalService } from "src/app/shared/services/discount-modal.service";
import { LoadingService } from "src/app/shared/services/loading.service";
import { BreadcrumbService } from "src/app/shared/services/breadcrumb.service";
import { SelfAttendanceService } from "src/app/shared/services/self-attendance.service";
import { CookieService } from "ngx-cookie-service";
import { TimeoutService } from "src/app/shared/services/timeout-data.service";
import { ECommerceService } from "src/app/services/e-commerce.service";

// Validators
import { CheckoutData } from "../../shared/model/checkout-data";
import {
  braspagReasonCode,
  errorMapping,
  handleIntegrationError,
  mappedCheckoutErrors,
  braspagTryAgainErrors,
  adyenReasonCode,
  sydleOneModalErrors
} from "../../shared/constants/errors";
// Components
import { CartComponent } from "../../shared/components/cart/cart.component";
import { DialogAlertComponent } from "../../shared/components/dialog-alert/dialog-alert.component";
// Utils
import { TimeoutData } from "src/app/shared/model/timeout-data";
import { CheckoutSuccessData } from "../../shared/model/checkout-success-data";
import { PaymentMethodOption } from "src/app/shared/model/payment-method-option";
import { DialogData } from "src/app/shared/model/dialog-data";
import { environment } from "../../../environments/environment";
import { Contexts } from "../../shared/enum/contexts";
import { filter, finalize, pairwise } from "rxjs/operators";
import { MatDialog } from "@angular/material/dialog";
import { hideChangePlanProducts } from "../../shared/constants/single-plan-products";
const ADYEN_CLIENTID_LIVE = "AU0Z-TP9t5_9196agaBN6ZD3UAwypdP1IX8ZYH3PcNNAQMXUTDQlChruXqQEhyI6-NKBKowN6ydkj477";


@Component({
    // tslint:disable-next-line: component-selector
    selector: "pme-checkout-payment",
    templateUrl: "./payment.component.html",
    styleUrls: ["./payment.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CheckoutPaymentComponent implements AfterViewInit, OnDestroy {
  // Child Components


  @ViewChild(PaymentFormComponent) paymentForm: PaymentFormComponent;
  @ViewChild(CartComponent) cartComponent: CartComponent;

  showCart = true;
  suggestionMessage: SuggestionMessage;
  purchaseOrigin: string;
  cart: Cart;
  customer: Customer;
  termOfUseUrl: string;
  adyenCardError: string;
  retentionCount = 0;
  selectedOptionInstallmentMSG: any;
  paymentMethod: CustomerPaymentMethod;
  notLoggedSale = false

  // Provisioning variables
  userId: string;
  businessId: string;
  additionalData: any;

  // Control Variables
  submitting: boolean = false;
  classificationIdentifier: string;
  classificationName: string;
  product: string;
  step = "pagamento";
  heroData: any = {};
  showHero = false;
  couponUrl: string;

  paymentOptions: Array<PaymentMethodOption> = [];
  changeProductText: string;
  changeProductLink: string;
  cardTitle: string;

  retentionCart: Cart;
  originalCart: Cart;

  context: string = Contexts.sale;
  discountBadge: string;

  previousUrl: string;
  currentUrl: string;
  isVendaDeslogada: boolean;
  invalidChecksum: boolean;

  // creditCardData: CreditCardData;
  creditCardsData: CreditCardData[];
  isACreditCardError: boolean = false;
  maxLimitCreditCards: boolean;
  isTelevendas: boolean;
  isDelend: boolean;

  checkoutSubscription: any;

  timeoutTime;

  hiddenAdobeDtm = false;

  constructor(
    private cookieService: CookieService,
    private timeoutService: TimeoutService,
    private checkoutService: CheckoutService,
    private discountModalService: DiscountModalService,
    private customerService: CustomerService,
    public sessionStorageService: SessionStorageService,
    private productService: ProductService,
    private route: ActivatedRoute,
    private router: Router,
    public cartService: CartService,
    public dtmService: DtmService,
    public dialog: MatDialog,
    private utils: UtilsService,
    private loading: LoadingService,
    private breadcrumb: BreadcrumbService,
    private selfAttendanceService: SelfAttendanceService,
    private eCommerceService: ECommerceService
  ) {
    breadcrumb.addBreadcrumb("Forma de pagamento");
    // Registrando ultima URL visitada
    this.router.events
      .pipe(filter((event) => event instanceof RoutesRecognized, pairwise()))
      .subscribe((event) => {
        this.previousUrl = this.currentUrl || this.router.url;
        this.currentUrl = (event as RoutesRecognized).url;
        sessionStorage.setItem("targetUrl", this.previousUrl);
      });

    this.purchaseOrigin = this.sessionStorageService.getPurchaseOrigin();

    this.sessionStorageService.clearSessionStorage(["name", "email"]);
    this.classificationIdentifier = this.sessionStorageService.checkAndSetClassification(this.route);
    this.classificationName = this.sessionStorageService.getClassificationName();
    this.product = this.sessionStorageService.getProduct();
    this.notLoggedSale = this.sessionStorageService.getNotLoggedSale();

    // Gets the UserID and BusinessId from SessionStorage
    this.getProvisioningParametersFromSessionStorage();

    // Loading essential customer data
    if (!this.customerService.getCurrentCustomer()) {
      this.customerService.getCustomerOnSessionStorage();
    }

    this.customer = this.customerService.getCurrentCustomer();

    // in case it dont load, return to previous page
    if (!this.customer) {
      this.navigateBack();
    } else {
      // Atualiza os dados de validacao no sessionStorage
      this.sessionStorageService.setValidationDataFromCustomer(this.customer);
    }

    this.route.queryParams.subscribe((params) => {
      if (params.userId && params.businessId) {
        this.userId = params.userId;
        this.businessId = params.businessId;
      }

      if (params.coupon) {
        this.couponUrl = params.coupon;
      }

      if (params.plan) {
        this.product = params.plan;
      }

      if (params.package) {
        this.product = params.package;
      }
    });

    loading.addTask(2);

    selfAttendanceService.getStoredCreditCards(this.userId, this.businessId, null)
      .subscribe(results => {
        this.creditCardsData = results[0].length ? results[0] : null;
        this.maxLimitCreditCards = results[1];

        this.suggestionMessage = results[2]


        loading.finishTask();
      }, () => loading.finishTask());

    // selfAttendanceService.getStoredCreditCard(this.userId, this.businessId)
    // 	.subscribe(r => {
    // 		this.creditCardData = r;
    // 		loading.finishTask();
    // 	}, () => loading.finishTask());



    this.timeoutTime = this.eCommerceService.getTimeForTimeout()
      .subscribe(res => {
        this.timeoutTime = res.timeForTimeout;
      }, (err) => {
        this.timeoutTime = 200;
      });

    this.hiddenAdobeDtm = this.purchaseOrigin === 'oneClickPurchase';
  }
  recieveSelectedOptionMSG(event) {
    this.selectedOptionInstallmentMSG = event;
  }
  handleDeleteCreditCard(accountPaymentDataId: string): void {
    this.loading.addTask(2);

    this.selfAttendanceService.removeCreditCard(this.userId, this.businessId, accountPaymentDataId)
      .subscribe(results => {
        this.creditCardsData = results[0].length ? results[0] : null;
        this.maxLimitCreditCards = results[1];
        this.loading.finishTask();
      }, () => this.loading.finishTask());

    this.loading.finishTask();
  }

  ngOnDestroy(): void {
    if (this.checkoutSubscription) {
      this.checkoutSubscription.unsubscribe();
    }
  }

  ngAfterViewInit() {
    if (!this.utils.validateQueryParams({
      userId: this.userId,
      businessId: this.businessId
    })) {
      this.utils.returnToLoginPage();
      return;
    }

    // Adobe Analytics - Padronizacao Setembro/2020
    this.fillCartWithUrlParameters();
    // this.validateCartCoupon();

    this.changeProductLink = sessionStorage.getItem("shopWindowRoute");
    if (this.changeProductLink === "meu-plano") {
      this.changeProductText = "Mudar plano";
      this.cardTitle = "Plano selecionado";
    } else if (this.changeProductLink === "meu-pacote") {
      this.changeProductText = "Mudar pacote";
      this.cardTitle = "Pacote selecionado";
    }

    // Remove o botao de "Mudar plano/pacote" caso o produto seja unitario
    if (hideChangePlanProducts.includes(this.classificationIdentifier)) {
      this.changeProductText = null;
      this.changeProductLink = null;
    }

    this.dtmService.customLoaded(["AddToCart"], "Sydle-checkout");
    this.isVendaDeslogada = sessionStorage.getItem('vendaDeslogada') !== "true";
    this.isTelevendas = sessionStorage.getItem('isTelevendas') === 'true';
    this.isDelend = sessionStorage.getItem('isDelend') === 'true';

    let mapped = getDtm(this.isTelevendas ? Dtm.Pagamento.replace("SYDLE", "SYDLE:TELEVENDAS") : Dtm.Pagamento, this.classificationIdentifier);
    this.dtmService.pageLoaded(Dtm.Pagamento, this.isVendaDeslogada, mapped);
    this.dtmService.sendPageLoadEvent();
    if (!this.isTelevendas) {
      this.dtmService.productsLoaded([{
        identifier: this.product,
        classificationName: this.classificationName && Mapping[this.classificationName] || this.classificationName
      },]);
    }

    this.discountModalService.discountModalConfig.subscribe((newDiscountModalConfig) => {
      try {
        let discountModalConfig = JSON.parse(newDiscountModalConfig);
        if (discountModalConfig && discountModalConfig.timeToActivatePayment) {
          setTimeout(() => {
            if (this.router.url.indexOf('pagamento') > -1) {
              this.discountModalService.setReachedTheModalTime(true);
              //Alterar parametro
            }
          }, discountModalConfig.timeToActivatePayment * 1000);
          //verificar f5 comportamento do reachedTheTimeModal
        }
      } catch (err) { }
    });

  }

  fillCartWithUrlParameters() {
    const cart = this.cartService.getCurrentCart();
    let discounts = null;
    let sessionCoupon = sessionStorage.getItem("coupon");
    if (cart && cart.couponIdentifier && !this.couponUrl) {
      this.couponUrl = cart.couponIdentifier;
      discounts = [this.couponUrl];
    } else if (sessionCoupon && !this.couponUrl) {
      this.couponUrl = sessionCoupon;
      discounts = [this.couponUrl];
    } else if (!cart && this.couponUrl) {
      // Carrinho inicializando, e com cupom vindo da URL
      discounts = [this.couponUrl];
    }

    this.additionalData = this.sessionStorageService.getAdditionalData();

    const cartId = cart && cart._id ? cart._id : null;
    const cartType = cart && cart.type ? cart.type : "SALE";
    const productIdentifier = this.sessionStorageService.getProduct();

    this.cartService.simulate(cartId, cartType, productIdentifier, 'PAYMENT', discounts, this.userId, this.businessId, null, this.additionalData).subscribe(simulatedCarts => {
      // Validar checksum
      if (simulatedCarts[0] && simulatedCarts[0].invalidCS === true) {
        this.invalidChecksum = true;
      }

      this.cartService.setCarts(simulatedCarts);
      if (this.cartService.origin === 'RETENÇÃO') {
        this.context = Contexts.retention;
        this.handleRetention();
      } else if (this.cartService.origin === 'VENDA') {
        if (this.cartComponent && this.cartComponent.cart && !this.cartComponent.cart.allowSaleWithoutPayment) {
          // const creditCardCart = this.cartService.carts.find(cart => cart.paymentMethod.identifier === 'CREDIT_CARD');
          // if (creditCardCart) {
          // 	this.cartService.setCartByPaymentMethod('CREDIT_CARD');
          // } else {
          // 	this.cartService.setCartByPaymentMethod('BANK_BILLET');
          // }

          // this.cartService.setCartByPaymentMethod('CREDIT_CARD');
          this.cartService.setCartByPaymentMethod(this.cartService.carts[0].paymentMethod.identifier);
          this.cartComponent.update();
          // Preenche as formas de pgto disponiveis
          const carts = this.cartService.getCarts();
          if (carts) {
            if (this.isDelend) {
              const creditCardCart = carts.find(c => c.paymentMethod.identifier === "CREDIT_CARD")
              this.paymentOptions = [creditCardCart.paymentMethod]
            } else {
              carts.forEach(cartData => {
                this.paymentOptions.push(cartData.paymentMethod);
                if (cartData.discountBadge) {
                  this.discountBadge = cartData.discountBadge;
                }
              });
            }
          }

          this.cart = this.cartService.getCurrentCart();

          // Atualiza o validationData no carrinho atual, caso ja exista
          this.cartComponent.setCouponValidationData();

          if (this.cart.tdu) {
            this.termOfUseUrl = this.cart.tdu;
          } else {
            this.showCustomError('termOfUsedIntegrationError');
          }
        } else {
          // this.cartService.setCartByPaymentMethod('BANK_BILLET');
          this.cartComponent.update();

          // Preenche as formas de pgto disponiveis
          const carts = this.cartService.getCarts();
          if (carts) {
            carts.forEach(cartData => {
              this.paymentOptions.push(cartData.paymentMethod);
              if (cartData.discountBadge) {
                this.discountBadge = cartData.discountBadge;
              }
            });
          }

          this.cart = this.cartService.getCurrentCart();

          // Atualiza o validationData no carrinho atual, caso ja exista
          this.cartComponent.setCouponValidationData();
          if (this.cartComponent.cart.product.automaticRecharge) {
            this.cartComponent.allowAutomaticRecharge = false;
          } else {
            this.cartComponent.allowAutomaticRecharge = null;
          }

          if (this.cart.tdu) {
            this.termOfUseUrl = this.cart.tdu;
          } else {
            this.showCustomError('termOfUsedIntegrationError');
          }
        }

        if (this.purchaseOrigin === 'oneClickPurchase') {

          this.paymentOptions = this.paymentOptions.sort((a, b) => {
            if (a.identifier === 'CREDIT_CARD') {
              return -1;
            } else if (b.identifier === 'CREDIT_CARD') {
              return 1;
            }
            return 0;
          });


          this.cartService.setCartByPaymentMethod('CREDIT_CARD');
          this.cartComponent.update();
          let oneClickPurchaseData = this.sessionStorageService.getOneClickPurchaseData();
          if (oneClickPurchaseData && !oneClickPurchaseData.changePayment) {
            this.onPaymentFormSubmitted({
              identifier: "CREDIT_CARD",
              paymentConditionIdentifier: "consultaCreditCard1X", // sempre 1 parcela
              "accountPaymentDataId": oneClickPurchaseData.accountPaymentDataId,
              "sameCard": true,
              "isAdyen": true,
              card: {
                "brand": oneClickPurchaseData.brand,
                "cardNumber": oneClickPurchaseData.cardNumber,
              }
            });
            return;
          }

        }
      }

      this.additionalData = this.sessionStorageService.getAdditionalData();

      if (this.classificationIdentifier && this.classificationIdentifier === 'consulta-e-recuperacao-de-dividas') {
        if (this.cartService.carts && this.cartService.carts.length === 1) {
          if (this.cartService.carts[0].paymentMethod.identifier !== 'CREDIT_CARD') {
            this.customer.provisioningParameter.allowAutomaticRecharge = false;
          } else if (!this.additionalData.disableRecharge) {
            if (this.businessId !== "600b2b05bb708c15e7f39d67") {
              this.cartComponent.activateAutomaticRecharge(true);
            }
          }
        } else {
          if (this.businessId !== "600b2b05bb708c15e7f39d67") {
            this.cartComponent.activateAutomaticRecharge(true);
          }
        }
      }
    }, (err) => {
      // Erro na simulacao de carrinho
      if (err.error.generalMessages[0].text === "consulta_em_confianca") {
        this.heroData.type = 'error';
        this.heroData.title = 'Produto Inválido';
        this.heroData.contents = ['Você não pode consumir esse produto neste momento!'];
        this.heroData.showButton = true;
        this.heroData.buttonName = 'Voltar';
        this.heroData.redirectURL = this.classificationIdentifier + "/checkout/" + this.sessionStorageService.getShopWindowRoute();
        this.showHero = true;
      }

      handleIntegrationError(err);
    }, () => { // when complete
      if (this.invalidChecksum) {
        this.openErrorDialog('invalidChecksum');
      }
    });
  }

  onAutomaticRechargeChange(event) {
    this.sessionStorageService.setValidationData({
      "byParameter": {
        "allowAutomaticRecharge": event
      }
    });

    this.customer.provisioningParameter.allowAutomaticRecharge = event;
    this.updateCurrentCustomer();
  }

  updateCurrentCustomer(): void {
    this.customerService.setCurrentCustomer(this.customer);
  }

  setSubmitting(submitting: boolean) {
    this.submitting = submitting;

    if (submitting) {
      this.breadcrumb.disableBreadcrumb();
    } else {
      this.breadcrumb.enableBreadcrumb();
    }
  }

  onPaymentFormSubmitted(paymentData) {
    if (this.purchaseOrigin === 'oneClickPurchase') {
      this.loading.addTask(2);
      this.submitting = true;
    }

    this.setSubmitting(true);
    this.isACreditCardError = false;

    if (this.paymentForm) {
      this.paymentForm.redirectUrl = null;
    }

    this.discountModalService.setReachedTheModalTime(false);

    if (this.invalidChecksum) {
      this.showCustomError('invalidChecksum');
      return;
    }
    let triggerMessagem = "Finalizar pagamento";

    // Gets the most updated cart
    this.dtmService.customClickEvent(triggerMessagem);
    this.cart = this.cartService.getCurrentCart();

    if (this.retentionCount === 1) {
      if (paymentData.identifier === "CREDIT_CARD") {
        this.retentionCart.validationData = this.cart.validationData;
        this.cart = this.retentionCart;
        paymentData.paymentConditionIdentifier = "creditCard6X";
      }
    }

    const products = this.cart.product;
    const discounts = this.cart.appliedDiscounts;
    let customer = this.customerService.getCurrentCustomer();
    const paymentMethod = paymentData;
    const sellerId = this.cart.sellerId;
    const cartId = this.cart._id;


    //Flag venda deslogada
    if (this.notLoggedSale && this.cart.validationData) {
      this.cart.validationData.notLoggedSale = this.notLoggedSale;
    }

    const validationData = this.cart.validationData || {};
    validationData.fraudnetData = paymentData.fraudnetData || {};
    // TODO - como mapear mudanca de forma de pgto quando o form eh de saldo insuficiente??
    if (this.cart.paymentMethod.identifier !== paymentMethod.identifier && this.context !== Contexts.retention) {
      this.showCustomError("invalidPaymentOption");
      this.setSubmitting(false);
      return;
    }

    if (this.purchaseOrigin === 'oneClickPurchase') {
      customer.provisioningParameter.allowAutomaticRecharge = false;
    }
    const checkoutData = new CheckoutData(
      products,
      discounts,
      customer,
      paymentMethod,
      sellerId,
      this.isTelevendas ? 'televendasEcommerce' : 'e-commerce',
      cartId,
      validationData

    );

    this.cartService.log("Realizando checkout do carrinho " + checkoutData.toString());


    let timeoutId = window.setTimeout(() => {
      let timeoutData = new TimeoutData(
        paymentMethod.identifier,
        paymentMethod.card?.brand,
        products,
        discounts
      );

      this.timeoutService.setTimeoutData(timeoutData);

      this.router.navigateByUrl(
        `${this.classificationIdentifier}/checkout/processamento`
      );

    }, 1000 * this.timeoutTime);

    let creditCardPaymentErrorData = JSON.parse(sessionStorage.getItem('creditCardPaymentErrorData'));
    if (paymentMethod.identifier === 'CREDIT_CARD' && creditCardPaymentErrorData) {
      this.sessionStorageService.setAdditionalData({
        byParameter: {
          viewedCreditCardPaymentError: creditCardPaymentErrorData.viewedCreditCardPaymentError,
          triggeredSecondaryCardAutoSelectFeature: creditCardPaymentErrorData.triggeredSecondaryCardAutoSelectFeature
        }
      });
    }

    this.checkoutSubscription = this.checkoutService.doCheckout(checkoutData).pipe(
      finalize(
        () => {
          if (this.purchaseOrigin === 'oneClickPurchase') {
            this.loading.removeAllTasks();
            //this.sessionStorageService.clearSessionStorage(['oneClickPurchase', 'oneClickPurchaseData']);
          }
        }
      )
    ).subscribe(
      (checkoutSuccessData: CheckoutSuccessData) => {


        this.checkoutService.setCheckoutSuccessData(checkoutSuccessData);
        clearTimeout(timeoutId);

        if (checkoutSuccessData.redirectConsentURL) {
          window.location.href = checkoutSuccessData.redirectConsentURL;
        } else {
          this.router.navigateByUrl(
            `${this.classificationIdentifier}/checkout/sucesso`
          );
        }
      },
      (error) => {
        clearTimeout(timeoutId);
        this.setSubmitting(false);
        console.table(error);
        console.error(error);
        this.showCustomError("checkoutError", error);
      }
    );



  }

  navigateBack() {
    this.router.navigateByUrl(`${this.classificationIdentifier}/checkout/identificacao`);
  }

  onPaymentConditionSelected(paymentConditionOption) {
    this.cartService.paymentOptionChanged.next(paymentConditionOption);
  }

  handleCartUpdate() {
    const carts = this.cartService.getCarts();
    if (carts) {
      const noPaymentNeededCart = carts.find(cart => cart.allowSaleWithoutPayment);

      if (noPaymentNeededCart && noPaymentNeededCart.allowSaleWithoutPayment &&
        noPaymentNeededCart.saleMessageInfo && this.paymentForm) {
        this.cart.allowSaleWithoutPayment = true;
        this.paymentForm.hasPaymentCreditCard = false;
        this.paymentForm.hasPaymentBankBillet = false;
        this.cartComponent.allowAutomaticRecharge = false;
        this.cart.saleMessageInfo = noPaymentNeededCart.saleMessageInfo;
        this.paymentOptions = [];

        const cart = carts.filter(cartData => cartData.paymentMethod.identifier === 'BANK_BILLET')[0];
        this.paymentOptions.push(cart.paymentMethod);
      } else {
        this.cart.saleMessageInfo = null;
        this.cart.allowSaleWithoutPayment = false;
        this.paymentOptions = [];
        carts.forEach((cartData) => {
          this.paymentOptions.push(cartData.paymentMethod);
        });
      }

      this.paymentForm.handleCartUpdated(this.paymentOptions);
    }
  }

  onPaymentMethodSelected(paymentMethod: string) {
    if (this.cartComponent) {
      this.cartComponent.paymentSelected(paymentMethod);
    }
  }

  getProvisioningParametersFromSessionStorage() {
    this.userId = this.sessionStorageService.getUserId();
    this.businessId = this.sessionStorageService.getBusinessId();

    // Se não tiver user e business na session storage e veio da vitrine híbrida
    let hybridPackageRedirect = Boolean(this.cookieService.get('hybridPackageRedirect'));
    if (!this.userId && !this.businessId && hybridPackageRedirect) {
      this.userId = this.cookieService.get('userId');
      this.businessId = this.cookieService.get('businessId');
    }

    this.dtmService.userLoaded({
      userId: this.userId,
      businessId: this.businessId,
      clientId: SYDLEClientID,
    });
  }

  showCustomError(customErrorKey: string, integrationError?: any) {
    let integrationErrorMessage: any;

    switch (customErrorKey) {
      case "termOfUsedIntegrationError":
        this.paymentForm.addValidationError(
          errorMapping[customErrorKey]
        );

        // Analytics
        this.dtmService.customErrorLoaded(["error"], {
          errorDetail: errorMapping[customErrorKey],
          errorMessage: errorMapping[customErrorKey],
        });

        this.paymentForm.redirectUrl = environment.serasaHomePage;
        break;
      case "invalidPaymentOption":
        this.paymentForm.addValidationError(
          errorMapping[customErrorKey]
        );

        // Analytics
        this.dtmService.customErrorLoaded(["error"], {
          errorDetail: "PaymentOptionInválido",
          errorMessage: errorMapping[customErrorKey],
        });

        this.paymentForm.redirectUrl = environment.serasaHomePage;
        break;
      case "checkoutError":

        integrationErrorMessage = this.handleCheckoutErrors(integrationError);

        if (this.context !== Contexts.retention) {
          if (['RECENT_PURCHASE_MODAL', 'MODAL_FRAUDNET_PENDING_PURCHASE', 'FRAUDNET_REJECT', 'MODAL_EXISTS_BANKBILLET_MENSAL_PLAN', 'MODAL_EXISTS_BANKBILLET_SDSN', 'MODAL_EXISTS_BANKBILLET_MONITORE', 'MODAL_EXISTS_PIX_MENSAL_PLAN', 'MODAL_EXISTS_PIX_SDSN', 'MODAL_EXISTS_PIX_MONITORE', 'WATCHLIST_INVESTIGATE', 'WATCHLIST_REJECT_PIX', 'WATCHLIST_REJECT_BOLETO', 'WATCHLIST_REJECT_CREDITCARD', 'MODAL_WATCHLIST_PENDING_PURCHASE', 'MODAL_EXISTS_PIX_CONSULTA', 'MODAL_EXISTS_BANKBILLET_CONSULTA'].indexOf(integrationErrorMessage.userMessage) >= 0) {
            this.openErrorDialog(integrationErrorMessage.userMessage);
          } else {
            this.paymentForm.addValidationError(
              integrationErrorMessage.userMessage
            );
          }
        }

        // Analytics
        if (integrationErrorMessage.errorString || integrationErrorMessage.userMessage) {
          this.dtmService.customErrorLoaded(["error"], {
            errorDetail: integrationErrorMessage.errorString,
            errorMessage: integrationErrorMessage.userMessage,
          });
        } else {
          // Erro de timeout na requisicao de venda
          this.dtmService.customErrorLoaded(["error"], {
            "errorDetail": "HttpErrorResponse",
            "errorMessage": "Erro de timeout durante a venda: " + integrationErrorMessage.message
          });
        }
        break;
      case "invalidChecksum":
        this.paymentForm.addValidationError(
          errorMapping[customErrorKey]
        );

        // Analytics
        this.dtmService.customErrorLoaded(["error"], {
          errorDetail: errorMapping[customErrorKey],
          errorMessage: errorMapping[customErrorKey],
        });

        this.paymentForm.redirectUrl = environment.serasaHomePage;
        break;
      default:
        break;
    }
    this.paymentForm.submitting = false;
    this.paymentForm.enableFields("all");
  }

  private handleRetention() {
    if (!this.retentionCount && sessionStorage.getItem("retentionCount") !== "0") {
      this.retentionCount = Number(sessionStorage.getItem("retentionCount"));
    }

    if (this.context === Contexts.retention) {
      this.originalCart = this.cartService.getCartByPaymentMethod(
        "BANK_BILLET"
      );
      if (this.originalCart.discountBadge) {
        this.discountBadge = this.originalCart.discountBadge;
      }
      if (this.originalCart.discountBadge) {
        this.discountBadge = this.originalCart.discountBadge;
      }
      if (this.retentionCount === 1) {
        this.dtmService.pageLoaded(Dtm.RetencaoErroPagamento, this.isVendaDeslogada, getDtm(Dtm.RetencaoErroPagamento, this.classificationIdentifier));
        this.dtmService.sendPageLoadEvent();
        this.retentionCart = this.cartService.getCartByPaymentMethod(
          "CREDIT_CARD"
        );
        this.paymentOptions = [
          this.retentionCart.paymentMethod,
          this.originalCart.paymentMethod,
        ];
      } else if (this.retentionCount === 2) {
        this.paymentOptions = [this.originalCart.paymentMethod];
        if (this.paymentForm) {
          this.paymentForm.handleCartUpdated(this.paymentOptions);
        }
      }
    } else {
      this.cartService.simulate(this.cart._id, "RETENTION", this.cart.product.identifier, 'RETENTION',
        null, null, null, this.retentionCount, this.additionalData)
        .subscribe(
          (carts) => {
            if (carts && carts.length) {
              this.context = Contexts.retention;
              this.cartService.setCarts(carts);
              this.originalCart = this.cartService.getCartByPaymentMethod(
                "BANK_BILLET"
              );
              if (this.originalCart.discountBadge) {
                this.discountBadge = this.originalCart.discountBadge;
              }
              if (this.retentionCount === 1) {
                this.dtmService.pageLoaded(Dtm.RetencaoErroPagamento, this.isVendaDeslogada, getDtm(Dtm.RetencaoErroPagamento, this.classificationIdentifier));
                this.dtmService.sendPageLoadEvent();
                this.retentionCart = this.cartService.getCartByPaymentMethod("CREDIT_CARD");
                this.paymentOptions = [this.retentionCart.paymentMethod, this.originalCart.paymentMethod];
              } else if (this.retentionCount === 2) {
                this.paymentOptions = [this.originalCart.paymentMethod];
              }
            }
          },
          (error) => {
            this.showCustomError("cartIntegrationError", error);
          }
        );
    }
  }

  handleCheckoutErrors(error: any): any {
    const resultError: any = {};
    try {
      this.isACreditCardError = false;

      if (typeof error === "string") {
        error = JSON.parse(error);
      }

      if (error.status !== null && error.error) {
        resultError.status = error.status;
        resultError.endpoint = error.url && error.url.substring(error.url.indexOf("/api/1") + 6);
        resultError.name = error.name;

        resultError.handledError = !!error.error._messages.filter((message) => {
          return message.code !== null;
        });

        resultError.errors = error.error._messages.filter((message) => {
          return message.type === "ERROR" && message.text !== "";
        });

        resultError.warnings = error.error._messages.filter((message) => {
          return message.type === "WARNING";
        });

        let parseObj;
        try {
          parseObj = JSON.parse(resultError.errors[0].text);
        } catch (err) { }

        if (parseObj && parseObj.context !== undefined) {

          resultError.context = parseObj.context;
          resultError.userMessage = parseObj.message;
          resultError.errorCode = resultError.errors[0].code || parseObj.code;
          resultError.errors[0].text = resultError.userMessage;

        } else {
          resultError.userMessage = resultError.errors[0].text;
          resultError.errorCode = resultError.errors[0].code;
        }

        this.paymentForm.braspagTryAgainErrors = Boolean(braspagTryAgainErrors[resultError.userMessage]);

        resultError.errorString = `${resultError.context || "SYDLE"}:HTTP:${resultError.errorCode || resultError.status}:POST/${resultError.endpoint}:${JSON.stringify(resultError.errors.map(({ text }) => text))}:${JSON.stringify(resultError.warnings)}`;

        if (resultError.errorCode === "402" &&
          resultError.userMessage === "Não autorizado. Saldo insuficiente.") {
          this.retentionCount += 1;
          sessionStorage.setItem("retentionCount", this.retentionCount.toString());
          this.showCart = false;
          this.handleRetention();
        } else if (braspagReasonCode[resultError.userMessage]) {
          resultError.userMessage = braspagReasonCode[resultError.userMessage];
        } else if (adyenReasonCode[resultError.userMessage]) {
          resultError.userMessage = adyenReasonCode[resultError.userMessage];
        } else if (mappedCheckoutErrors[resultError.userMessage]) {
          resultError.userMessage = mappedCheckoutErrors[resultError.userMessage];
        } else if (resultError.userMessage.indexOf("java") >= 0 ||
          resultError.userMessage.indexOf("Java") >= 0 ||
          resultError.userMessage.indexOf("Script") >= 0 ||
          resultError.userMessage.indexOf("script") >= 0 ||
          resultError.userMessage.indexOf("elastic") >= 0 ||
          resultError.userMessage.indexOf("Elastic") >= 0) {

          if (resultError.userMessage.indexOf("BP901") >= 0) {
            resultError.userMessage = braspagReasonCode["BP901"];
          } else if (resultError.userMessage.indexOf("Could not find an acquirer account") >= 0) {
            resultError.userMessage = adyenReasonCode["Could not find an acquirer account"];
          } else {
            resultError.userMessage = "Ocorreu um erro ao processar a solicitação, por favor tente novamente em alguns instantes.";
          }

          this.paymentForm.redirectUrl = environment.serasaHomePage;
        } else if (sydleOneModalErrors[resultError.userMessage]) {
          let errors = error.error._messages.filter(err => err.type == "ERROR" && err.text !== "");


          resultError.userMessage = errors.map(err => err.text).join(".");;
        }
        let generalMessageText
        try {
          generalMessageText = error.error.generalMessages[0]?.text;

          const parsedText = JSON.parse(generalMessageText); //trata erro referente ao cartão

          const context = parsedText?.context;
          const message = parsedText?.message;

          if (generalMessageText) {


            if (context === "ADYEN") {

              resultError.userMessage = message;


              this.adyenCardError = message;
              this.isACreditCardError = true;
              if (!this.creditCardsData) {
                this.isACreditCardError = false;

              }
            } else {

              this.isACreditCardError = false;
              this.adyenCardError = null;

            }

          }
        } catch (err) {

        }
      }
    } catch (e) {
      // resultError.errorString = JSON.stringify(error);

      resultError.userMessage = "Ocorreu um erro ao processar a sua solicitação, tente novamente em alguns instantes.";

      this.paymentForm.redirectUrl = environment.serasaHomePage;
    }

    if (resultError.context && resultError.context === "Braspag") {
      this.paymentForm.isBraspagError = true;

      if (!this.paymentForm.braspagTryAgainErrors) {
        resultError.userMessage += " Por favor, verifique os dados informados, utilize outro cartão ou efetue o pagamento com boleto.";
      }
    }

    return resultError;
  }

  /** Abre dialog em caso de erro durante a venda deslogada */
  openErrorDialog(dialogData: string, errorDetail?: string, errorMessage?: string) {
    let data = DialogData.fromPreset(dialogData, {
      classificationName: this.classificationName,
      businessId: this.businessId,
      userId: this.userId
    });

    let dialogRef = this.dialog.open(DialogAlertComponent, {
      disableClose: true,
      panelClass: 'pme-dialog-alert-panel',
      autoFocus: false,
      data: data
    });

    if (['RECENT_PURCHASE_MODAL', 'FRAUDNET_REJECT', 'MODAL_EXISTS_BANKBILLET_MENSAL_PLAN', 'MODAL_EXISTS_BANKBILLET_SDSN', 'MODAL_EXISTS_BANKBILLET_MONITORE', 'MODAL_EXISTS_PIX_MENSAL_PLAN', 'MODAL_EXISTS_PIX_SDSN', 'MODAL_EXISTS_PIX_MONITORE', 'MODAL_EXISTS_BANKBILLET_CONSULTA', 'MODAL_EXISTS_PIX_CONSULTA'].indexOf(dialogData) >= 0) {
      dialogRef.afterClosed().subscribe(result => {
        if (result && result.doCheckout) {
          this.doCheckoutRecentPurchaseModal();
        } else if (result && result.disableCreditCard) {
          this.disableCreditCardAfterFraudnetReject();
        } else if (result && result.changeToBankBillet) {
          this.changeToBankBilletAfterFraudnetReject();
        } else if (result && result.doCheckoutInThisPlan) {
          this.doCheckoutAfterExistsModalForAnotherPlan();

        }
      });
    } else {
      // Analytics
      this.dtmService.customErrorLoaded(['error'], {
        errorDetail: errorMapping[dialogData],
        errorMessage: errorMapping[dialogData],
      });
    }
  }

  doCheckoutRecentPurchaseModal() {
    this.cart.validationData.ignoreRecentPurchase = true;
    this.cartService.setCart(this.cart);
    if (this.paymentForm.isAdyen) {
      this.paymentForm.onAdyenSubmit();
    } else {
      this.paymentForm.onSubmit();
    }
  }

  doCheckoutAfterExistsModalForAnotherPlan() {
    this.cart.validationData.ignoreAnotherPlan = true;
    this.cartService.setCart(this.cart);
    if (this.paymentForm.isAdyen) {
      this.paymentForm.onAdyenSubmit();
    } else {
      this.paymentForm.onSubmit();
    }
  }

  disableCreditCardAfterFraudnetReject() {
    if (this.paymentForm.paymentData && this.paymentForm.paymentData.sameCard) {
      this.paymentForm.disableSubmitCreditCard = true;
    } else {
      this.paymentForm.paymentData = new CustomerPaymentMethod("CREDIT_CARD");
    }

    if (this.cartComponent.allowAutomaticRecharge === true) {
      this.cartComponent.onAutomaticRechargeClick({ "checked": false });
    }
  }

  changeToBankBilletAfterFraudnetReject() {
    if (this.paymentForm.paymentData && this.paymentForm.paymentData.sameCard) {
      this.paymentForm.disableSubmitCreditCard = true;
    } else {
      this.paymentForm.paymentData = new CustomerPaymentMethod("CREDIT_CARD");
    }
    if (this.cartComponent.allowAutomaticRecharge === true) {
      this.cartComponent.onAutomaticRechargeClick({ "checked": false });
    }
    // this.paymentForm.selectedIndex = 1;
    // this.paymentForm.storePaymentMethod(1);
    this.paymentForm.storePaymentMethodByIdentifier("BANK_BILLET");
  }

  /**
   * Retorna um userMessage de erro para erros de HttpIntegrationError
   * @param error
   */
  getUserMessageForHttpIntegrationError(error: any): string {
    if (error && error.error) {
      error = error.error;

      if (error._messages && error._messages.length) {
        let isCvvInvalid = error._messages.some(errorMsg => errorMsg.text.includes("Código de segurança inválido"));
        if (isCvvInvalid) {
          return "Não autorizado. Código de segurança inválido. Revise os dados ou insira outro cartão.";
        }

        let isCardInexistent = error._messages.some(errorMsg => errorMsg.text.includes("Cartão inexistente"));
        if (isCardInexistent) {
          return "Transação não autorizada por conter dados inválidos. Revise os dados informados ou utilize outro cartão.";
        }

        let isCardRestricted = error._messages.some(errorMsg => errorMsg.text.includes("Cartão restrito"));
        if (isCardRestricted) {
          return "Cartão restrito. Não autorizado. Revise os dados informados ou utilize outro cartão.";
        }

        let isBP901Error = error._messages.some(errorMsg => errorMsg.text.includes("BP901"));
        if (isBP901Error) {
          return "Ocorreu um erro ao realizar a transação. Por favor revise os dados ou insira outro cartão.";
        }

        // Outras mensagens que podem ser retornadas pelo ONE
        // let errors = error._messages.filter(err => err.type == "ERROR");
        // if (errors && errors.length) {
        // 	return errors.map(err => err.text).join(".");
        // }
      }
    }

    return "Ocorreu um erro ao processar a solicitação, tente novamente em alguns instantes!";
  }
}
